import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { socket } from "../../../../socket";

import styles from "../../GameSelector.module.css";

function AddRoomNumber() {
  const [isRoomNumberAdded, setIsRoomNumberAdded] = useState<boolean>(false);
  const [roomNumber, setRoomNumber] = useState<string>();
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    function onRejectJoinRoom(errorCode: string) {
      let msg = "";

      switch (errorCode) {
        case "not found":
          msg = t("AddRoomNumber.errors.notFound");
          break;
        case "game started":
          msg = t("AddRoomNumber.errors.gameStarted");
          break;
        case "game over":
          msg = t("AddRoomNumber.errors.gameOver");
          break;
        case "room full":
          msg = t("AddRoomNumber.errors.roomFull");
          break;
      }

      setErrorMsg(msg);
    }

    socket.on("reject join room", onRejectJoinRoom);

    return () => {
      socket.off("reject join room", onRejectJoinRoom);
    };
  }, [t]);

  if (errorMsg && isRoomNumberAdded) {
    setIsRoomNumberAdded(false);
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRoomNumber(e.target.value);
  };

  const handleOnSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsRoomNumberAdded(true);
    socket.connect();
    socket.emit("join room", roomNumber);
  };

  return (
    <div className="AddRoomNumber">
      <h2 className={styles.title}>{t("AddRoomNumber.title")}</h2>
      <div className={styles.body}>
        <form className={styles.form} onSubmit={handleOnSubmit}>
          <div className={styles.group}>
            <input
              className={styles.field}
              id="code"
              name="code"
              type="text"
              placeholder={String(t("AddRoomNumber.placeholder"))}
              onChange={handleOnChange}
              required
              autoFocus
            />
            <label className={styles.label} htmlFor="code">
              {t("AddRoomNumber.label")}
            </label>
          </div>
          {errorMsg && <div className={styles.error}>{errorMsg}</div>}
          <div className={styles.actions}>
            {isRoomNumberAdded ? (
              <button
                className={[styles.button, "loading-state"].join(" ")}
                type="submit"
                disabled
              >
                {t("App.submitting")}
              </button>
            ) : (
              <button className={styles.button} type="submit">
                {t("AddRoomNumber.submitButton")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddRoomNumber;
